import { render } from "./Dimensions.vue?vue&type=template&id=428c358c&ts=true"
import script from "./Dimensions.vue?vue&type=script&lang=ts"
export * from "./Dimensions.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\caffeine\\caffeineshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__